var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messageJoin"},[_vm._v(" "+_vm._s(_vm.$t('message.user_left',{user: _vm.eventStateKeyDisplayName(_vm.event)}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }